import type { SxProps, Theme } from "@mui/material/styles";

export const formStack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.25),
});

export const logoRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
});

export const logoButton: SxProps<Theme> = {
  width: 72,
  height: 72,
  borderRadius: 2.25,
  border: "2px dashed",
  borderColor: "divider",
  bgcolor: "background.default",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "text.secondary",
  overflow: "hidden",
  flex: "none",
};

export const logoImage: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

export const logoHint: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
};

export const twoColumnGrid: SxProps<Theme> = (theme) => ({
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: theme.spacing(1.75),
});

export const footerRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.75),
  borderTop: 1,
  borderColor: "divider",
  pt: 2.25,
});

export const savedFlash: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  fontSize: "0.75rem",
  color: "success.main",
  fontWeight: 600,
};

export const hiddenInput: SxProps<Theme> = {
  display: "none",
};
